/* eslint-disable no-sequences */
import { FormRegisterType } from 'components/1-atoms/BaseInput';
import { BaseSelect, BaseSelectProps } from 'components/1-atoms/BaseSelect';
import { ErrorMessage } from 'components/1-atoms/ErrorMessage';
import * as React from 'react';

export interface SelectProps extends BaseSelectProps {
	className?: string;
	children: React.ReactNode;
	formRegister?: FormRegisterType;
	disabled?: boolean;
	errors?: string[];
	onChange: React.ChangeEventHandler<HTMLSelectElement>;
}
export const Select: React.FC<SelectProps> = ({ children, formRegister, className, disabled, errors, ...selectProps }: SelectProps) => {
	return (
		<div className={className}>
			<BaseSelect formRegister={formRegister} disabled={disabled} hasErrors={errors && errors.length > 0} {...selectProps}>
				{children}
			</BaseSelect>
			{errors && errors.length > 0 && errors.map((error) => <ErrorMessage key={error}>{error}</ErrorMessage>)}
		</div>
	);
};
